module.exports = {"360105001":"站前街道","360105002":"幸福街道","360105100":"招贤镇","360105101":"梅岭镇","360105102":"罗亭镇","360105103":"太平镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360105.json
// module id = 1152
// module chunks = 0